var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{attrs:{"heading":_vm.$t('solutionList.heading'),"item-component":"v-card-solution","items":_vm.items}})}
var staticRenderFns = []

export { render, staticRenderFns }